import { useCallback, useEffect, useRef } from 'react';
import { recordPostView } from '@/data/connect';

const VIEW_DWELL_MS = 5000;
const VIEWABILITY_CONFIG = {itemVisiblePercentThreshold: 60};

//Feed view tracking: a post counts as viewed only after staying viewable
//(>=60% visible) for VIEW_DWELL_MS. recordPostView dedups per session and the
//PostViews(postID, personID) PK dedups server-side — one row per person/post.
//onViewableItemsChanged identity must stay stable (list requirement), so it's
//a useCallback with refs doing the bookkeeping.
export default function usePostViewTracking() {
    const timers = useRef(new Map());

    useEffect(() => {
        const pending = timers.current;
        return () => {
            pending.forEach(clearTimeout);
            pending.clear();
        };
    }, []);

    const onViewableItemsChanged = useCallback(({changed}) => {
        (changed || []).forEach(entry => {
            const postID = entry?.item?.id;
            if(!postID) return;

            if(entry.isViewable){
                if(timers.current.has(postID)) return;
                timers.current.set(postID, setTimeout(() => {
                    timers.current.delete(postID);
                    recordPostView({postID});
                }, VIEW_DWELL_MS));
            }
            else{
                const timer = timers.current.get(postID);
                if(timer){
                    clearTimeout(timer);
                    timers.current.delete(postID);
                }
            }
        });
    }, []);

    return {onViewableItemsChanged, viewabilityConfig: VIEWABILITY_CONFIG};
}
